import { getCalendarEntryByFolderId, getCalendarFolderId } from 'owa-calendar-cache';
import { getCalendarSurfaceStore } from 'owa-calendar-surface-surface-store';
import { unselectOtherCalendars } from 'owa-calendar-surface-calendars-store';
import { isOldModelSharedCalendar } from 'owa-calendar-properties';
import { linkedCalendarSelected } from '../actions/internalActions';
import { logUsage } from 'owa-analytics';
import { removeCalendarItems } from 'owa-calendar-surface-dategrid';
import { selectCalendar } from '../actions/selectCalendar';
import { trace } from 'owa-trace';
import persistCalendarsSelection from '../actions/persistCalendarsSelection';
import { CalendarEntry } from 'owa-graph-schema';

export default function showSelectedCalendarOnly(calendar: CalendarEntry) {
    // Select the calendar first
    selectCalendar(calendar, undefined, true);

    trace.info('Unselecting all the remaining selected calendars');
    unselectOtherCalendars(calendar);

    const folderId = getCalendarFolderId(calendar);
    const surfaceItemsForOtherCalendars = getCalendarSurfaceStore().calendarItems.filter(
        item => item.ParentFolderId.Id !== folderId
    );

    removeCalendarItems(
        surfaceItemsForOtherCalendars.map(itemToRemove => itemToRemove.ItemId.Id),
        getCalendarSurfaceStore()
    );

    // Since we unselect all calendars but one, we need to reset the count of selected linked calendars count.
    // We will force that by passing in the reset flag.
    linkedCalendarSelected(isOldModelSharedCalendar(getCalendarEntryByFolderId(folderId)), true);

    persistCalendarsSelection(
        calendar.calendarId.mailboxInfo.userIdentity,
        true /* viaShowThisCalendarOnly */
    );

    logUsage('ShowThisCalendarAlone', {}, { isCore: true });
}
